import { makeAutoObservable } from "mobx";
import {
  deleteShiftWork,
  getShiftWorkById,
  saveOrUpdate,
  pagingShiftWork,
  getAllShiftWorks,
  generateWorkingSlot,
} from "app/services/ShiftWorkService";

import { SearchObject } from "app/common/Model/SearchObject";
import { toast } from "react-toastify";
import { ShiftWork } from "app/common/Model/ShiftWork";
import { checkSearchObject } from "app/common/LocalFunction";

export default class ShiftWorkStore {
  listAllShiftWork = [];
  searchShiftWork = new SearchObject();
  pageShiftWork = null;
  selectedShiftWork = null;
  openFormCreateOrEdit = false;
  openFormSlot = false;
  openConfirmDelete = false;
  recentlyUpdated = false;

  constructor() {
    makeAutoObservable(this);
  }

  getAllShiftWorks = async () => {
    return await getAllShiftWorks()
      .then(({ data }) => {
        this.listAllShiftWork = data || [];
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu có lỗi", "Thông báo");
      });
  };
  pagingShiftWork = async () => {
    return await pagingShiftWork(this.searchShiftWork)
      .then(({ data }) => {
        this.pageShiftWork = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu có lỗi", "Thông báo");
      });
  };

  handleChangeFormSearch = (searchShiftWork) => {
    this.searchShiftWork = checkSearchObject(
      this.searchShiftWork,
      searchShiftWork
    );
    this.pagingShiftWork();
  };

  handleOpenFormCreateOrEdit = (shiftWorkId) => {
    if (Boolean(shiftWorkId)) {
      getShiftWorkById(shiftWorkId).then(({ data }) => {
        this.selectedShiftWork = data;
        this.openFormCreateOrEdit = true;
      });
    } else {
      this.selectedShiftWork = new ShiftWork();
      this.openFormCreateOrEdit = true;
    }
  };

  handleOpenFormSlot = (shiftWork) => {
    this.selectedShiftWork = shiftWork;
    this.openFormSlot = true;
  };

  saveOrUpdateShiftWork = (shiftWork, { setSubmitting }) => {
    saveOrUpdate(shiftWork)
      .then(() => {
        this.selectedShiftWork = null;
        toast.success("Lưu dữ liệu thành công!");
        this.handleClosePopup();
        this.pagingShiftWork();
        this.recentlyUpdated = true;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lưu dữ liệu có lỗi");
      })
      .finally(() => setSubmitting(false));
  };

  generateWorkingSlot = async (shiftWorkId, numberOfSlot, startSlotNumber) => {
    await generateWorkingSlot(shiftWorkId, numberOfSlot, startSlotNumber)
      .then((response) => {
        toast.success("Tạo lịch thành công");
      })
      .catch((error) => {
        console.error("Error:", error);
      });

    this.pagingShiftWork();
  };

  handleDelete = (shiftWork) => {
    this.selectedShiftWork = { id: shiftWork?.id };
    this.openConfirmDelete = true;
  };

  handleConfirmDelete = async () => {
    return await deleteShiftWork(this.selectedShiftWork?.id)
      .then(() => {
        if (
          this.searchShiftWork?.pageIndex > 1 &&
          this.pageShiftWork?.content?.length === 1
        ) {
          this.searchShiftWork.pageIndex -= 1;
        }
        toast.success("Xóa bản ghi thành công!");
        this.handleClosePopup();
        this.pagingShiftWork();
        this.recentlyUpdated = true;
      })
      .catch((err) => {
        console.error(err);
        toast.error("Xóa bản ghi có lỗi", "Thông báo");
      });
  };

  handleClosePopup = () => {
    this.openFormCreateOrEdit = false;
    this.openConfirmDelete = false;
    this.openFormSlot = false;
  };

  resetStore = () => {
    this.searchShiftWork = new SearchObject();
    this.pageShiftWork = null;
    this.selectedShiftWork = null;
    this.openFormCreateOrEdit = false;
    this.openConfirmDelete = false;
  };

  //for choosing shiftWork in ChooseShiftWorkPopup.jsx
  listShiftWork = [];
  shiftWorkIdSet = null;

  isValidShiftWork = (shiftWork) => {
    if (shiftWork && shiftWork?.id) return true;
    console.error("Invalid manipulated element");
    return false;
  };

  addShiftWork = (shiftWork) => {
    if (!this.isValidShiftWork(shiftWork)) return;
    this.listShiftWork.push(shiftWork);
    this.shiftWorkIdSet.add(shiftWork?.id);
  };

  initializelistShiftWork = (shiftWorks) => {
    this.shiftWorkIdSet = new Set();
    this.listShiftWork = [];
    if (shiftWorks && shiftWorks?.length > 0) {
      for (let i = 0; i < shiftWorks.length; i++) {
        this.addShiftWork(shiftWorks[i]);
      }
    }
  };

  removeShiftWork = (shiftWork) => {
    if (!this.isValidShiftWork(shiftWork)) return;
    if (this.shiftWorkIdSet.has(shiftWork?.id)) {
      this.shiftWorkIdSet.delete(shiftWork?.id);
    } else {
      console.error("Element is not exist");
    }
  };

  isExist = (shiftWork) => {
    if (!this.isValidShiftWork(shiftWork)) return;
    return this.shiftWorkIdSet.has(shiftWork?.id);
  };

  getShiftWorkIdSet = () => {
    return this.shiftWorkIdSet;
  };

  getListShiftWork = () => {
    const bufferIdSet = new Set();
    const data = [];
    if (this.listShiftWork && this.listShiftWork?.length > 0) {
      for (let i = 0; i < this.listShiftWork.length; i++) {
        const shiftWork = this.listShiftWork[i];
        if (this.isExist(shiftWork) && !bufferIdSet.has(shiftWork?.id)) {
          data.push(shiftWork);
          bufferIdSet.add(shiftWork?.id);
        }
      }
    }
    this.listShiftWork = data;
    return data;
  };
}
